import React, { useContext, useEffect } from 'react';
import Banner from '../../components/Profile/cards/Banner';
// import Achievement from "../../components/Profile/cards/Achievement";
// import Projects from "../../components/Profile/cards/Projects";
// import Edu from "../../components/Profile/cards/Edu";
// import Skills from "../../components/Profile/cards/Skills";
// import Certifications from "../../components/Profile/cards/Certifications";
import RadarSkills from '../../components/Profile/cards/RadarSkills';
// import Navbar from "../../components/Navigation/Navbar";
import { UserContext } from '../../utils/contexts/UserContext';
import { Navigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { getUser } from '../../services/Auth/authService';
import SmashLoader from '../../components/Loader/SmashLoader';
import NotFound from '../NotFound/NotFound';

const Profile = () => {
  const { uuid } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const { user, isUniversity } = useContext(UserContext);

  useEffect(() => {
    if (uuid) {
      setIsLoading(true);
      getUser(uuid)
        .then((res) => {
          setCurrentUser(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [uuid]);

  if (!uuid && isUniversity) {
    return <Navigate to={`/universities/${user.university.uuid}`} />;
  }

  if (isLoading) {
    return (
      <div className="w-full flex justify-center sm:px-6 lg:px-8 xl:px-0">
        <SmashLoader />
      </div>
    );
  }
  if (uuid && !currentUser) {
    return (
      <div className="w-full flex justify-center sm:px-6 lg:px-8 xl:px-0">
        <NotFound />
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center sm:px-6 lg:px-8 xl:px-0">
      <div className="w-full max-w-5xl gap-6 flex-col flex items-center py-10">
        <Banner userData={uuid ? currentUser : user} />
        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2 space-y-6">
            {/* <RadarSkills /> */}
            {/* <Achievement /> */}
            {/* <Projects /> */}
          </div>
          <div className="col-span-1 space-y-4">
            <div className="w-96" />
            {/* <Edu /> */}
            {/* <Skills /> */}
            {/* <Certifications /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
